import { createAction } from 'redux-actions';
import types from './types';

export default createAction(types.SET_LANGUAGE);




// WEBPACK FOOTER //
// ./src/infraMonitor/localization/actions.js